import React from 'react';
import SMReputationListView from 'components/reputations/SMReputationListView';
import SMSpaceResource from 'resources/SMSpaceResource';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import sprintf from 'sprintf';
import SMSearchListTableRow from 'components/search/SMSearchListTableRow';
import SMSpaceMapView from './SMSpaceMapView';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMOwnerSummaryView from 'components/owners/SMOwnerSummaryView';
import SMRestClient from 'lib/SMRestClient';
import SMUserResource from 'resources/SMUserResource';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';

class SMSpaceView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      reputations: [],
      space: this.props.space,
      rooms: this.props.rooms,
      documentImages: 0,
      targetFavoriteRoom: {},
      latestUpdatedFavoriteList: {},
      isSMUFavoriteListSelectViewOpen: false
    };
  }

  componentDidMount() {
    // $('img.cld-hidpi').cloudinary_update();
    this.setState({ documentImages: document.images.length });
    
    let q = {page: 1, per_page: 3};
    SMSpaceResource.getReputations(this.state.space.username, q, (reputations, error, xhr)=>{
      const links = SMRestClient.getLinks(xhr);
      this.setState({
        reputations: reputations
      });
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    let currentDocumentImages = document.images.length;
    if (currentDocumentImages != this.state.documentImages) {
      // $('img.cld-hidpi').cloudinary_update();
      this.setState({ documentImages: currentDocumentImages });
    }
  }

  favoriteDidSelect(favorable, isFavorite, rowIndex){
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    if (isFavorite) {
      // もしお気に入りに登録されている場合はリスト選択のモーダルを表示
      this.showFavoriteListSelectForm(favorable);
    } else {
      let room = favorable;
      let responseHandler = (data, error, xhr)=>{
        let rooms = this.state.rooms;
        if (error) {
          return;
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          rooms[rowIndex] = room;
          this.setState({
            rooms: rooms,
            latestUpdatedFavoriteList: data.favorite_list,
          });
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }

  showFavoriteListSelectForm(room, e){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // SMSearchListTableRow delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  render() {

    const space = this.state.space;
    const rooms = this.state.rooms;

    let coverImageUrl = this.props.noImage;
    if (space.cover_photo) {
      coverImageUrl = SMFormatHelper.imageURLWithTransform(space.cover_photo);
      if (!SMAppHelper.isMobile()) {
        coverImageUrl = SMFormatHelper.imageURLWithTransform(coverImageUrl,
          {width: 1200, height: 670});
      }
    }

    const googleMapUrl = sprintf("https://www.google.com/maps?q=%s,%s+(%s)",
      space.latitude,
      space.longitude,
      encodeURIComponent(space.name_text)
    );
    let rows = [];
    rooms.forEach((room, index) => {
      rows.push(
        <SMSearchListTableRow
          key={room.id}
          room={room}
          noRoomImage={this.props.noImage}
          rowIndex={index}
          canSlide={true}
          delegate={this}
          latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList} />
      );
    });

    return(
      <div className="site-main" itemScope itemType="http://schema.org/LodgingBusiness">
        <div className="mod-heroimg">
          <img src={coverImageUrl} alt={space.name} className="mod-heroimg__img" />
          <div className="mod-heroimg__bg"><h1 className="mod-heroimg__title" itemProp="name">{space.name}<span className="mod-heroimg__subtitle">{space.space_type_text}</span></h1>
          </div>
        </div>
        <div className="page__odd page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <h2 className="page-subtitle">この会場について</h2>
                <p className="page-lineheight" dangerouslySetInnerHTML={{__html:SMFormatHelper.description(space.description)}} />
              </div>
              <div className="col-sm-12 col-md-4 side-fixed side-place">
                <div className="space-side">
                  <div className="site-sidebar">
                    <h2 className="site-sidebar__headline">会場地図</h2>
                    <div className="side-place__map">
                      <SMSpaceMapView space={space} hasInfoWindow={false} />
                    </div>
                    <div className="site-sidebar__inner page-lineheight">
                      <p className="side-place__map-address" itemProp="address" itemScope itemType="http://schema.org/PostalAddress">{"〒" + space.postal_code}<br />{space.state_text}{space.city}{space.address_1}{space.address_2}</p>
                      <p className="side-place__map-station" dangerouslySetInnerHTML={{__html:SMFormatHelper.description(space.access)}} />
                      <p className="a__underline"><a href={googleMapUrl} target="_blank">Google Mapで見る</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <div className="search-list__sort place-list__sort">
                  <span className="service-select">
                    <select name="sort" defaultValue="popular" className="service-select__sort">
                      <option value="popular">おすすめ順</option>
                      <option value="inexpensive">価格が安い順</option>
                      <option value="capacity">収容人数順</option>
                      <option value="created">新着順</option>
                    </select>
                  </span>
                </div>
                <h2 className="page-subtitle fl">スペース一覧</h2>
                <div className="units-list clear">
                  <ul className="row">
                    {rows}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page__odd page__padding">
          <div className="container">
            <div className="row mod-review">
              <div className="col-sm-12 col-md-8">
                <h2 className="page-subtitle">評価とレビュー</h2>
                <ul className="mod-review__head" itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
                  <li className="mod-review__head-star">
                    <a href={Routes.reputations_space_path(space.username)}>{SMRenderHelper.renderReviewStars(space.reputation_score)}</a>
                  </li>
                  <li className="mod-review__head-rating" itemProp="ratingValue">{space.reputation_score}</li>
                  <li itemProp="reviewCount">
                    <a href={Routes.reputations_space_path(space.username)} className="space-head__list-number">{space.reputation_count}件</a>
                  </li>
                </ul>
                <SMReputationListView reputated="Space" reputations={this.state.reputations} />
                <div className="mod-more__link">
                  <a href={Routes.reputations_space_path(space.username)} className="button-blue pt13 pb13 w200">レビューをもっと見る</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <SMOwnerSummaryView owner={space.owner} canInquiry={false} />
            </div>
          </div>
        </div>
        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />
      </div>
    );
  }

}
export default SMSpaceView;



// WEBPACK FOOTER //
// ./app/javascript/components/spaces/SMSpaceView.jsx